/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // clear cart  when cart total = 0 (normaly free gifts)
    if (cart.total_price === 0 && cart.item_count >= 1) {
        await fetch("/cart/clear.js");
        await openCart();
        return;
    }

    // remove the free creamer if any
    let updates = {};
    cart.items.forEach(item => {
        if (item.handle === "collagen-probiotic-creamer-15-servings-free") {
            // remove the free creamer from the cart
            updates[item.key] = 0; // set quantity to 0 to remove it
        }
    });
    if (Object.keys(updates).length > 0) {
        // perform the update to remove free creamer
        cart = await updateCart({updates: updates});

        // re-load cart
        openCart(true);
        return;
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    const variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelectorAll('.headerCart').forEach(element => element.setAttribute("data-count", cart.item_count));
    document.querySelector('#miniCartHeaderTitle').textContent = `Your Cart (${cart.item_count})`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartUpsell").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    /********* Expiration Countdown *********/

    // check if localStorage cartExpiration exists
    if (sessionStorage.getItem("cartExpiration") === null) {
        sessionStorage.setItem("cartExpiration", new Date().getTime() + 5 * 60 * 1000);
    }

    // get expiration time
    const expirationTime = new Date(parseInt(sessionStorage.getItem("cartExpiration")));

    // refresh countdown function
    function refreshCountdown() {
        // calculate time left
        const currentTime = new Date();
        const timeLeft = expirationTime - currentTime;

        // hide expiration if time is up
        if (timeLeft <= 0) {
            document.querySelector("#miniCartHeaderExpiration").classList.remove("active");
        } else {
            const minutesRemaining = Math.floor(timeLeft / 1000 / 60);
            const secondsRemaining = Math.floor(timeLeft / 1000) % 60;
            document.querySelector("#miniCartHeaderExpiration").classList.add("active");
            document.querySelector("#miniCartHeaderExpiration").textContent = `🚨 Your cart will expire in ${minutesRemaining}:${secondsRemaining < 10 ? "0" : ""}${secondsRemaining} minutes 🚨`;
        }
    }

    // run refresh countdown
    refreshCountdown();
    setInterval(refreshCountdown, 1000);

    /********* End Expiration Countdown *********/

    /********* Free Shipping Check *********/

        // by default, assume free shipping is available
    let hasFreeShipping = cart.items_subtotal_price >= 2699;

    // if update free shipping elements
    if (hasFreeShipping) {
        document.querySelector("#miniCartHeaderShipping").classList.add("active");
        document.querySelector("#miniCartFooterShipping").classList.add("active");
    } else {
        document.querySelector("#miniCartHeaderShipping").classList.remove("active");
        document.querySelector("#miniCartFooterShipping").classList.remove("active");
    }

    /********* End Free Shipping Check *********/

    // reset body container
    document.querySelectorAll(".miniCartBodyItem:not(.gift)").forEach(element => element.remove());

    // determine if they're eligible for free gift
    if (document.querySelector(".miniCartBodyItem.gift")) {
        // default to false
        let isEligibleForFreeGift = false;

        // loop over each line item and check if cartSettings.free_product_trigger_product_ids has the product id
        cart.items.forEach(item => {
            if (cartSettings.free_product_trigger_product_ids.includes(item.product_id)) {
                isEligibleForFreeGift = true;
            }
        });

        // hide free gift if under threshold
        if (isEligibleForFreeGift) {
            document.querySelector(".miniCartBodyItem.gift").classList.add("active");
        } else {
            document.querySelector(".miniCartBodyItem.gift").classList.remove("active");
        }
    }

    // setup the cart
    cart.items.forEach(item => {
        // skip if free gift property
        const hasGroup = item.properties && item.properties["__group"];
        const isGift = hasGroup && item.properties["__gift"];

        // skip products with __gift: true since they'll be grouped later
        if (isGift) {
            return;
        }

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariants">${item.variant_title}</div>`;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemVariants">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML, note we are taking in an item variable
        function priceHTML() {
            let HTML = price(item.final_line_price);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (variantIDToCompareAtPrice[item.variant_id]) {
                comparePrices.push(variantIDToCompareAtPrice[item.variant_id] * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    HTML += `
                        <s>${price(greatestComparePrice)}</s>
                    `;
                }
            }

            return HTML;
        }

        // addon html html
        function giftHTML() {
            // check if this item has a group id
            if (!hasGroup) {
                return "";
            }

            // save group id
            const groupID = item.properties["__group"]

            // find all cart items with the same group id that are addons
            const groupGifts = cart.items.filter(item => {
                return item.properties && item.properties["__group"] === groupID && item.properties["__gift"]
            });

            // check if there are any addons
            if (groupGifts.length === 0) {
                return "";
            }

            // render html
            let HTML = "";

            // generate html for each item
            groupGifts.forEach(item => {
                HTML += `
                    <div class="miniCartBodyItemGiftsItem">
                        <img class="miniCartBodyItemGiftsItemImage" src="${item.featured_image.url}&width=200" alt="${item.featured_image.alt}">
                        <div class="miniCartBodyItemGiftsItemTitle">${item.product_title}</div>
                        <div class="miniCartBodyItemGiftsItemPrice">FREE</div> 
                    </div>
                `;
            });

            // return html string
            return `<div class="miniCartBodyItemGifts">${HTML}</div>`;
        }

        // set up the item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <a class="miniCartBodyItemLink" href="${item.url}">
                    <img class="miniCartBodyItemLinkImage" src="${item.featured_image.url}&width=400" alt="${item.featured_image.alt}">
                </a>
                <div>
                    <a class="miniCartBodyItemTitle" href="${item.url}">${item.product_title}</a>
                    ${variantHTML()}
                    ${subscriptionHTML()}
                    <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                </div>
                <div>
                    <div class="miniCartBodyItemQuantity">
                        <button class="miniCartBodyItemQuantityMinus" aria-label="Minus"></button>
                        <div class="miniCartBodyItemQuantityValue" aria-label="Quantity">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus ${item.product_title.includes("FREE Starter Kit") || item.original_line_price === 0 ? "disabled" : ""}"></button>
                    </div>
                    <button class="miniCartBodyItemRemove">Remove</button>
                </div>
                ${giftHTML()}
            </div>
        `);

        // get cart element
        const rootElement = document.querySelector(`.miniCartBodyItem[data-key="${item.key}"]`);

        // minus
        rootElement.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", async function () {
            if (item.quantity === 1) {
                rootElement.querySelector(".miniCartBodyItemRemove").click();
            } else {
                item.quantity--;
                await updateCartItem();
            }
        });

        // plus
        rootElement.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", async function () {
            item.quantity++;
            await updateCartItem();
        });

        // remove
        rootElement.querySelector(".miniCartBodyItemRemove").addEventListener("click", async function () {
            item.quantity = 0;
            await updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // create update js payload to remove all items at once
            let updatePayload = {};

            // check if this item has a group
            if (hasGroup) {
                // save group id
                const groupID = item.properties["__group"]

                // find all cart items with the same group id
                cart.items.forEach(itemLocal => {
                    if (itemLocal.properties && itemLocal.properties["__group"] === groupID) {
                        updatePayload[itemLocal.key] = item.quantity;
                    }
                });
            } else {
                updatePayload[item.key] = item.quantity;
            }

            // update cart
            cart = await updateCart({updates: updatePayload});

            // refresh cart
            await openCart(true);
        }
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // update total
    document.querySelector("#miniCartFooterSubtotalValue").textContent = price(cart.items_subtotal_price);
}

// Add Upsell function
document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
    const productID = element.dataset.product;
    const variantID = element.dataset.variant;
    const sellingPlanID = element.dataset.plan;

    // add to cart event
    element.querySelector(".miniCartUpsellItemATC").addEventListener("click", async function () {
        // start loading animation
        element.classList.add("loading");

        // create form data
        let formData = {
            quantity: 1,
            id: variantID,
            selling_plan: sellingPlanID
        };

        // clear cart
        await fetch("/cart/clear.js");

        // add product upsell
        await addProduct(formData, true);

        // remove loading animation
        element.classList.remove("loading");

        // re-open cart
        await openCart();
    });
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    // start loading
    this.classList.add("loading");

    // checkout
    await goToCheckout();

    // wait 300 ms
    await sleep(300);

    // stop loading
    this.classList.remove("loading");
});

// on link click, open cart - when we go live, this will be un-commented
document.querySelectorAll(`a[href="/cart"]`).forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}